import React from 'react';
import PropTypes from 'prop-types';

const UiExpandCollapseUpPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M8 7.205l-4.42 4.419a.5.5 0 0 1-.707 0l-.883-.884a.5.5 0 0 1 0-.707l5.656-5.657a.498.498 0 0 1 .708 0l5.656 5.657a.5.5 0 0 1 0 .707l-.883.884a.5.5 0 0 1-.708 0L8 7.204z"
    />
  );
};

UiExpandCollapseUpPath.propTypes = {
  fill: PropTypes.string,
};

export default UiExpandCollapseUpPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-expand-collapse-up.jsx